import React, {
    useState,
    useEffect,
} from "react";
import { AddDialog } from "../../Components/AddDialog.jsx";
import { Box, Grid, Stack, Tooltip, Typography } from "@mui/material";
import { faListUl } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { iconSize, myOwnFPColor } from "../../App/GridRenderers.jsx";
import { Arrayify } from "../../Functions/utils.jsx";
import { getScenarioInput } from "../Pdf/Generate.jsx";
import { useWindowDimensions } from "../../App/useWindowDimensions.jsx";

export const InfoViewPort = ({ clientJson,
    scen_uuid,
    scen_name,
    show,
    onClose,
    name,
    info
}) => {
    const { winHeight, winWidth } = useWindowDimensions();
    const [expand, setExpand] = useState(false)

    // console.log("TIVP:", scen_name)
    return (

        <InfoView
            clientJson={clientJson}
            scen_uuid={scen_uuid}
            scen_name={scen_name}
            width={expand ? winWidth - 35 * 4 : winWidth - (600 + 20) * 4}
            height={expand ? winHeight - 35 * 4 : winHeight - 500}
            onExpand={() => { console.log(expand); setExpand(!expand) }}

            open={show}
            onClose={onClose}
            info={info}
        />

    )
}

const infoTexts = (data, info) => {
    let json = {
        text: "",
        textA: [],
    }

    //console.log(data)
    //console.log(info)
    if (data.person.length > 0 && data.person[0][info]) {
        //console.log(data.person[0][info])

        data.person[0][info].forEach(e => {
            json.text += e + "\n"
            json.textA.push(e)
        });
    }

    //console.log(json)

    return json
}








export const InfoView = ({ clientJson,
    scen_uuid,
    scen_name,
    open,
    onClose,
    info,
}) => {
    const [scenInputs, setScenInputs] = useState({})


    const getData = async () => {
        let inputs = [1]

        // console.log("getData")
        let si = await getScenarioInput(clientJson, scen_uuid, inputs)

        // console.log(si[0])
        let sit = infoTexts(si[0], info)
        setScenInputs(sit)


    }
    const myClose = () => {
        onClose()
    }


    useEffect(() => {
        if (open) {
            getData();
        }
    }, [open])


    const emptyJson = {}
    const showInformation = (si) => {
        // console.log(si)
        return (
            <Stack >
                {(si !== emptyJson) && (
                    <ul>

                        <Grid container spacing={10} >
                            <Grid size={12} xs={1}>
                                {Arrayify(si.textA).map((item, i) => (
                                    <React.Fragment key={"RF" + i}>
                                        {(!item.includes('\t') && (

                                            <>
                                                {(item.includes("Information") && (
                                                    <Typography sx={{ mt: 6 }} variant="h6" gutterBottom>
                                                        {item}
                                                    </Typography>
                                                ))}
                                                {(!item.includes("Information") && (
                                                    <Typography variant="h6">
                                                        {item}
                                                    </Typography>
                                                ))}
                                            </>

                                        ))}
                                        {(item.includes('\t') && (
                                            <ul>
                                                <li>
                                                    {item.replace(/\t/g, '')}
                                                </li>
                                            </ul>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </Grid>

                        </Grid>

                    </ul>
                )}

            </Stack>
        )
    }


    // console.log("TIV: ", open)
    return (
        <AddDialog
            clientJson={null}
            c_callback={null}
            onClose={myClose}
            open={open}
            clients={[]}
            client={""}
            label={"Information: " + scen_name}
            onClientChange={() => { }}
            noButtons={true}
            accountType="Info"
            PrintFileName={"MyOwnFP: " + clientJson.name + (clientJson.spouseName ? "&" + clientJson.spouseName : "") + " Scenario: " + scen_name + "_Information"}
        >
            {open &&
                <Stack sx={{ mx: 20, mb: 10 }} spacing={2}>

                    {/* <Typography variant="h5">
                        Information
                    </Typography> */}
                    {showInformation(scenInputs)}

                </Stack >
            }
        </AddDialog >

    )
}
